import { Paper, Typography } from "@mui/material";
import React from "react";
import { useContextData } from "../hooks/useContextData";

const prices = [
  { searches: 3, price: 7 }, // $2.33 per search
  { searches: 8, price: 14 }, // $1.75 per search
  // { searches: 12, price: 17 }, // $1.42 per search
  { searches: 20, price: 19 }, // $0.95 per search - best value!
  { searches: 50, price: 40 }, // $0.75 per search - best value!
];
//probando cicd

type Props = {
  horizontal?: boolean;
  setSelectedPrice: React.Dispatch<React.SetStateAction<number | null>>;
  selectedPrice: number | null;
};

const PriceCards = ({ horizontal, setSelectedPrice, selectedPrice }: Props) => {
  const { theme } = useContextData();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: horizontal ? "row" : "column",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: horizontal ? 20 : 0,
      }}
    >
      {prices.map((price, index) => (
        <Paper
          elevation={5}
          sx={{
            cursor: "pointer",
            padding: 1,
            margin: 1.4,
            width: 200,
            alignSelf: "center",
            backgroundColor: theme === "dark" ? "#15121f" : "#FAFAFA",
            color: theme === "dark" ? "#FAFAFA" : undefined,
            border:
              selectedPrice === price.price
                ? theme === "dark"
                  ? "2px solid #FAFAFA"
                  : "2px solid #15121f"
                : "",
            "&:hover": {
              backgroundColor: theme === "dark" ? "#2b2640" : "#f0f0f0",
            },
          }}
          onClick={() => setSelectedPrice(price.price)}
        >
          <Typography>
            {price.searches} Search{price.searches > 1 && "es"} $
            {price.price.toFixed(2)}
          </Typography>
        </Paper>
      ))}
    </div>
  );
};

export default PriceCards;
